import React, {Component} from 'react';
import {Button, Modal, Form} from 'semantic-ui-react';
import MaskedInput from "react-text-mask";
import update from 'react-addons-update';
import 'react-day-picker/lib/style.css';
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Toast from "../extras/Toast";
import DataService from "../../functions/DataService";

const moneyMask = createNumberMask({
    prefix: '$',
});

class TipDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tip: {
                id: null,
                amount: 0
            },
            amount_error: false,
            sending: false,
            loading: true,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.toast = React.createRef();
    }

    handleAmountChange = (event) => {
        let value = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '':parseFloat(event.target.value.replace(/\D/g, ''));
        let tip = update(this.state, {
            tip: {
                amount: {
                    $set: value
                }
            }
        });
        this.setState(tip);
        if (event.target.value < 0) {
            this.setState({amount_error: true})
        } else {
            this.setState({amount_error: false});
        }
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.tip.amount <= 0 || this.state.tip.amount === '') {
            this.setState({amount_error: true});
        } else {
            this.setState({sending: true});
            if (this.state.tip.id) {
                DataService.put(this.state.tip, `api/tips/${this.state.tip.id}`, (res) => {
                    if (res.update) {
                        this.toast.current.show({message: 'Propina Actualizada!', type: 'success'});
                        this.handleToggleModal();
                        this.props.callbackSuccess()
                    } else {
                        this.toast.current.show({message: 'Tenemos un problema!', type: 'error'});
                    }
                })
            } else {
                DataService.post(this.state.tip, 'api/tips', (res) => {
                    if (res.save) {
                        this.toast.current.show({message: 'Propina Agregada!', type: 'success'});
                        this.handleToggleModal();
                        this.props.callbackSuccess()
                    } else {
                        this.toast.current.show({message: 'Tenemos un problema!', type: 'error'});
                    }

                })
                this.setState({sending: false})
            }
        }
    };

    handleToggleModal = (tip= null) => {
        if(tip){
            this.setState({tip});
        }
        this.setState({modal_show: !this.state.modal_show});
    };

    render() {
        return (
            <React.Fragment>
                <Modal size='mini' dimmer='inverted' open={this.state.modal_show} onClose={this.handleToggleModal}>
                    <Modal.Header>{this.state.tip.id ? 'Actualizar Propina' : 'Nueva Propina'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Input
                                    label='Valor'
                                    error={this.state.purchase_price_error}
                                    children={
                                        <MaskedInput
                                            mask={moneyMask}
                                            value={this.state.tip.amount}
                                            placeholder='Valor'
                                            onChange={this.handleAmountChange}
                                        />
                                    }
                                />
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleToggleModal} content="Cancelar"/>
                        <Button primary icon='save' labelPosition='left' disabled={this.state.sending}
                                loading={this.state.sending} onClick={this.handleSubmit}
                                content={this.state.tip.id ? 'Actualizar' : 'Guardar'}/>
                    </Modal.Actions>
                </Modal>
                <Toast ref={this.toast} />
            </React.Fragment>
        );
    }
}

export default TipDialog




// WEBPACK FOOTER //
// ./src/components/sale/TipDialog.js